// Split out of entities.ts so consumers that only need these runtime
// literals (e.g. useSignUpCodeValidation) don't have to pull in
// entities.ts's transitive chain to EnvConstants (`import.meta.env`),
// which breaks under Jest outside a mock factory.
export const SIGN_UP_CODE_TYPE = {
  INVITATION_CODE: 'INVITATION_CODE',
  REFERRAL_CODE: 'REFERRAL_CODE',
} as const;

export type InvitationCodeType = typeof SIGN_UP_CODE_TYPE.INVITATION_CODE;
export type ReferralCodeType = typeof SIGN_UP_CODE_TYPE.REFERRAL_CODE;

export const REFERRAL_CODE_STATUS = {
  ACTIVE: 'ACTIVE',
  INACTIVE: 'INACTIVE',
  DISABLED: 'DISABLED',
  NONE: '',
} as const;

export type ReferralCodeStatus =
  (typeof REFERRAL_CODE_STATUS)[keyof typeof REFERRAL_CODE_STATUS];
